













import {
  Component,
  Vue,
  Inject,
  Prop,
  namespace,
} from "nuxt-property-decorator";
import Form from "fourwaves-shared/src/components/Form.vue";
import { FormDto, FormEntryDto } from "fourwaves-shared";

@Component({
  components: {
    Form,
  },
})
export default class RegistrationForm extends Vue {
  @Inject() $validator;
  @Prop({ required: true }) form!: FormDto;
  @Prop({ required: true }) formData!: { [fieldId: string]: string };
  @Prop({ required: false, default: null })
  readonly formEntry!: FormEntryDto | null;

  @(namespace("events").Getter) isOrganizer!: boolean;

  mounted() {
    this.scrollToErrors();
  }

  public async onFormChanged(formData) {
    this.$emit("form-update", formData);
  }
}
